import { useState } from "react";
import { Piani } from "@/components/aziende/Piani";
import { PianiBridge } from "@/components/aziende/PianiBridge";
import { Calcolatore } from "@/components/aziende/Calcolatore";

export default function AziendePiani() {
  const [pcto, setPcto] = useState(false);
  return (
    <main data-testid="aziende-piani-page">
      <Piani pcto={pcto} setPcto={setPcto} />
      <PianiBridge />
      <Calcolatore pcto={pcto} setPcto={setPcto} />
    </main>
  );
}
